import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _Container from "styles-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/styles.js?styleId=Container";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'

export const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletUp: useDeviceType('isTabletUp')
  })
})
